module.exports = __webpack_public_path__ + "assets/entrance-question-cfc1c161.png";